module.exports = __webpack_public_path__ + "static/media/icon-event__europa-en-la-posguerra-hover.94e53db4.svg";